<div class="relative">
  <div class="flex gap-4 justify-end absolute -top-[52px] right-0">
    <ng-container *ngIf="eventMap.length > 4">
      <mat-icon class="text-[40px] !w-10 !h-10 text-gray-500 rounded-full bg-gray-100 relative z-50"
        [class.text-gray-200]="isAtStart" [class.cursor-pointer]="!isAtStart" (click)="goLeft()">chevron_left</mat-icon>
      <mat-icon class="text-[40px] !w-10 !h-10 text-gray-500 rounded-full bg-gray-100 relative z-50"
        [class.text-gray-200]="isAtEnd" [class.cursor-pointer]="!isAtEnd" (click)="goRight()">chevron_right</mat-icon>
    </ng-container>
  </div>

  <div #container class="flex overflow-hidden scroll-smooth">
    <div *ngFor="let group of eventMap"
      class="w-1/4 max-w-[25%] min-w-[25%] pl-4 pr-2 border-l-2 border-dotted relative">
      <div class="-ml-[18px] w-full bg-white pb-3">
        <p class="font-semibold text-gray-600">{{group.key}}</p>
      </div>

      <div class="max-h-[412px] overflow-auto pr-2 timeline-day">
        <div *ngFor="let item of group.events;let i = index" #card (click)="goToEvent(item)"
          class="rounded-xl relative transition-all cursor-pointer">
          <div class="rounded-xl shadow-md mb-3 cursor-pointer">
            <ig-image [src]="item.cover?.source" class="block overflow-hidden"
              cls="aspect-[3/2] w-full rounded-t-xl transition-all hover:scale-[1.03]"></ig-image>
            <div class="p-2 bg-white rounded-b-xl">
              <div class="text-sm font-semibold text-gray-600 mb-1 -mt-1 ellipsis">{{item.name}}</div>
              <div class="text-xs text-gray-500 max-lines-2 min-h-[32px]">
                <span>{{item.timeTwoLines?.date}}</span>
                <span *ngIf="item.eventTimes.length>1||item.timeTwoLines?.time" class="mx-2">·</span>
                <span>{{item.eventTimes.length>1?'Multiple times':item.timeTwoLines?.time}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>